import * as _ from "lodash";

export class BaseAPIService {
    getData<T>(response: any, defaultValue?: T): T {
        return _.get(response, 'data', defaultValue);
    }
}
